import { apiService } from './api';

interface StudioPreviewResult {
  success: boolean;
  previewUrl: string;
}

class StudioPreviewService {
  /**
   * Copies the current active edit to a user-scoped GCS preview slot and
   * returns the preview server URL for that slot.
   */
  async generatePreview(projectId: string): Promise<StudioPreviewResult> {
    const response = await apiService.post<StudioPreviewResult>(
      `/editor/project/${projectId}/studio-preview`,
      {},
      { timeout: 30000 }
    );
    return response.data;
  }
}

export default new StudioPreviewService();
